import confs from './confs.vue'

export default confs
